import { Modal } from "react-bootstrap";
import App from "../component/login/Login";
import { useState } from "react";
import Register from "../component/login/Register";
import LoginWithEmail from "../component/login/LoginWithEmail";

const LoginModalPopUp = ({ show, handleClose, checkoutClick }) => {
  const [activeTab, setActiveTab] = useState("login");
  

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  

  return (
    <Modal show={show} onHide={handleClose} centered className="custom-login-popup">
      <Modal.Header closeButton>
        <h2>LOGIN / SIGN UP</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="login-tab">
          <ul>
            <li onClick={() => handleTabClick("login")}>
              <span
                className={activeTab === "login" || activeTab === "emailLogin" ? "active nav-link" : "nav-link"
                }
              >
                LOGIN
              </span>
            </li>
            <li onClick={() => handleTabClick("register")}>
              <span
                className={activeTab === "register" ? "active nav-link" : "nav-link"
                }
              >
                CREATE A NEW ACCOUNT
              </span>
            </li>
          </ul>
        </div>
        {activeTab === "login" ? <App setActiveTab={handleTabClick} checkoutClick={checkoutClick} handleClose={handleClose} /> : activeTab === "emailLogin" ? <LoginWithEmail setActiveTab={handleTabClick} checkoutClick={checkoutClick} handleClose={handleClose} /> : <Register setActiveTab={handleTabClick} checkoutClick={checkoutClick} handleClose={handleClose} />}
      </Modal.Body>
    </Modal>
  );
};

export default LoginModalPopUp;
